import React, { useState } from 'react';

function AddEtapaModal({ isOpen, onClose, onAddEtapa }) {
  const [text, setText] = useState('');
  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim() === '') return;
    onAddEtapa(text);
    setText('');
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Adicionar Nova Etapa</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome da Etapa</label>
            <input type="text" value={text} onChange={(e) => setText(e.target.value)} required autoFocus />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn-cancel">Cancelar</button>
            <button type="submit" className="btn-save">Salvar Etapa</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddEtapaModal;